// src/api/reviews.js
import client from './client.js';

export const reviewsAPI = {
  getByProduct: (productId, params) => client.get('/reviews', { params: { product_id: productId, ...params } }),
  getById: (id) => client.get(`/reviews/${id}`),
  create: (data) => client.post('/reviews', data),
  update: (id, data) => client.put(`/reviews/${id}`, data),
  delete: (id) => client.delete(`/reviews/${id}`),
  addReply: (id, data) => client.post(`/reviews/${id}/reply`, data),
  approve: (id) => client.put(`/reviews/${id}/approve`),
};